module.exports = "<p-growl [value]=\"msgs\" [life]=\"5000\"></p-growl>\n<p-blockUI [blocked]=\"block\">\n    <mat-spinner class=\"spinner-centred\"></mat-spinner>\n</p-blockUI>\n<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main